export const SEARCH_TYPES = {
  BORROWER: 'borrowerSearch',
  COMPANY: 'comapniesSearch',
  GUARANTOR: 'guarantorSearch',
  SOLE_TRADER: 'soleTraderSearch',
};

export default { SEARCH_TYPES };
